import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Logo } from './Logo';

interface FestivalCreationHeaderProps {
  onBack: () => void;
  title?: string;
  stepName?: string;
}

export const FestivalCreationHeader: React.FC<FestivalCreationHeaderProps> = ({ onBack, title, stepName }) => {
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-[#0d0e12]/80 backdrop-blur-[10px] border-b border-zinc-900 w-full">
      <div className="flex flex-row items-center justify-between px-6 py-4 max-w-7xl mx-auto w-full">
        {/* Left: Logo */}
        <div className="flex items-center cursor-pointer order-1" onClick={() => navigate('/home')}>
          <Logo className="text-xl" />
        </div>

        {/* Right: Back Action */}
        <button 
          onClick={onBack} 
          className="text-zinc-500 hover:text-white transition-colors flex items-center text-xs font-black uppercase tracking-widest order-2"
        >
          <ChevronLeft className="w-4 h-4 mr-1" /> Retour
        </button>
      </div>
    </header>
  );
};
